import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            研究分类
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            从多个维度系统梳理援助交配现象，点击分类深入探索
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat, index) => {
            const colorClasses =
              cat.color === 'accent'
                ? 'bg-accent-50 border-accent-200/60 hover:border-accent-400 text-accent-800'
                : cat.color === 'primary'
                  ? 'bg-primary-50 border-primary-200/60 hover:border-primary-400 text-primary-800'
                  : 'bg-secondary-50 border-secondary-200/60 hover:border-secondary-400 text-secondary-800';

            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group flex flex-col items-center text-center p-6 rounded-xl border transition-all duration-300 hover:scale-[1.02] ${colorClasses}`}
              >
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50 mb-4">
                  <i className={`${cat.icon} text-xl`}></i>
                </span>
                <h3 className="font-heading font-semibold text-foreground-950 mb-2 text-sm">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                  {cat.description}
                </p>
                <span className="text-xs font-medium opacity-70">
                  {cat.articleCount} 篇文章
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}